import { Component, OnInit } from "@angular/core";
import {
  faPencil,
  faBan,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "../../../../interfaces/form-field.model";
import { ActivatedRoute, Router } from "@angular/router";
import { LocationService } from "src/app/services/autopac/location.service";
import {
  getEmptyGuid,
  isEmptyGuid,
} from "../../../../services/util.service";

@Component({
  selector: "app-location-master-detail",
  templateUrl: "./location-master-detail.component.html",
  styleUrls: ["./location-master-detail.component.css"],
})
export class LocationMasterDetailComponent implements OnInit {
  faPencil = faPencil;
  faBan = faBan;
  faPlus = faPlus;

  mode: string = "Add";
  locationId: string = getEmptyGuid();

  formFields: FormField[] = [
    {
      type: "text",
      id: "location",
      label: "Location",
      required: true,
      value: "",
    },
    {
      type: "text",
      id: "chequeFrom",
      label: "Cheque From",
      required: true,
      value: "",
    },
    {
      type: "text",
      id: "chequeTo",
      label: "Cheque To",
      required: true,
      value: "",
    },
    {
      type: "text",
      id: "currentCheque",
      label: "Current Cheque",
      required: true,
      value: "",
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private locationService: LocationService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.locationId = params["id"] ?? getEmptyGuid();

      if (!isEmptyGuid(this.locationId)) {
        this.mode = "Edit";
        this.loadLocationDetail();
      } else {
        this.mode = "Add";
        this.clearForm();
      }
    });
  }

  private loadLocationDetail(): void {
    this.locationService
      .getLocationDetail(this.locationId)
      .subscribe({
        next: (response) => {
          const data = response?.body?.d ?? response?.body;
          if (!data) return;

          this.setFieldValue("location", data.Location);
          this.setFieldValue("chequeFrom", data.ChequeFrom);
          this.setFieldValue("chequeTo", data.ChequeTo);
          this.setFieldValue("currentCheque", data.CurrentCheque);
        },
        error: (error) => {
          console.error("Error loading location detail:", error);
        },
      });
  }

  onSave(): void {
    if (this.mode === "Add") {
      this.addLocation();
      return;
    }
    this.updateLocation();
  }

  private addLocation(): void {
    const payload = {
      Location: this.getFieldValue("location"),
      ChequeTo: this.getFieldValue("chequeTo"),
      ChequeFrom: this.getFieldValue("chequeFrom"),
      CurrentCheque: this.getFieldValue("currentCheque"),
    };

    this.locationService.addLocation(payload).subscribe({
      next: () => {
        this.router.navigate(["../../location-master"], {
          relativeTo: this.route,
        });
      },
      error: (error) => {
        console.error("Error adding location:", error);
      },
    });
  }

  private updateLocation(): void {
    const payload = {
      __type: "KAPS.Model.Autopac.CrmLocation",
      Id: this.locationId,
      Location: this.getFieldValue("location"),
      ChequeFrom: this.getFieldValue("chequeFrom"),
      ChequeTo: this.getFieldValue("chequeTo"),
      CurrentCheque: this.getFieldValue("currentCheque"),
    };

    this.locationService.updateLocation(payload).subscribe({
      next: () => {
        this.router.navigate(["../../location-master"], {
          relativeTo: this.route,
        });
      },
      error: (error) => {
        console.error("Error updating location:", error);
      },
    });
  }

  onCancel(): void {
    this.router.navigate(["../../location-master"], {
      relativeTo: this.route,
    });
  }

  private getFieldValue(id: string): any {
    return this.formFields.find((f) => f.id === id)?.value ?? "";
  }

  private setFieldValue(id: string, value: any): void {
    const field = this.formFields.find((f) => f.id === id);
    if (field) field.value = value ?? "";
  }

  private clearForm(): void {
    this.formFields.forEach((f) => (f.value = ""));
  }
}
